import React from 'react';

import Button from '@dashboard/components/Button';
import { formatPrice } from '@dashboard/services/formatting';
import scaleBrackets from '@dashboard/services/scaleBrackets';

// Yearly upsell shown on the subscribe page while the monthly period is
// selected. Spells out the actual savings instead of just "2 months free".
const SwitchToYearlyOffer = ({ plan, scaleBracket, onSwitch }) => {
  const bracket =
    plan?.handle === 'scale' && scaleBracket
      ? scaleBrackets.find(b => b.value === scaleBracket)
      : null;

  const monthlyPrice = bracket ? bracket.monthlyPrice : plan?.monthlyPrice;
  const yearlyPriceFull = bracket ? bracket.yearlyPriceFull : plan?.yearlyPriceFull;

  if (!monthlyPrice || !yearlyPriceFull) return null;

  const fullYearAtMonthly = monthlyPrice * 12;
  const savings = fullYearAtMonthly - yearlyPriceFull;

  return (
    <div className="w-full rounded-lg border border-dashed border-foreground bg-muted p-4 flex items-center justify-between gap-x-4 my-6 text-left">
      <div>
        <div className="text-base font-semibold text-gray-900 dark:text-foreground">
          Get 2 months free with yearly billing
        </div>
        <div className="text-sm text-gray-600 dark:text-muted-foreground mt-0.5">
          Pay {formatPrice({ amount: yearlyPriceFull, currency: 'USD' })}/year instead of{' '}
          {formatPrice({ amount: fullYearAtMonthly, currency: 'USD' })} and save{' '}
          {formatPrice({ amount: savings, currency: 'USD' })}.
        </div>
      </div>
      <Button appearance="primary" onClick={onSwitch} className="shrink-0">
        Switch to yearly
      </Button>
    </div>
  );
};

export default SwitchToYearlyOffer;
